import { Scale, Total } from "@pdfking/math"

import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { Region } from "../Region"

/** Interstate, a poster calendar: its months in two columns either side of a picture up its middle, the year at the picture's head, the contact at its foot. */
export const Interstate: CalendarDesign = {
  cover: PictureCover({}),
  page: ({ body, contact, gap, page, short, year }) => {
    const picture = Slice.over(Region(page, 0.34, 0, 0.66, 1), body.y)
    const [left, right] = Slice.grid(body, 2, 1, Scale(body.width, 0.4))
    return [
      Area.titled(
        picture,
        "year",
        Slice.top(Slice.under(picture, Total(body.y, body.height)), Scale(short, 0.08))[0],
        `${year}`
      ),
      ...Area.months(left!, year, 1, gap, 1, 6),
      ...Area.months(right!, year, 1, gap, 7, 12),
      Area.footer(contact),
    ]
  },
  pages: "year",
}
